import { makeSelectors } from '@utils/css';

const modifiers = makeSelectors({
  hasImage: "_uqxhigx0du",
  hasAudio: "_uqxhhy48x1"
});
const wrapper = "_uqxwei1gyk";
const imageWrapper = "_uqxipemv1z";
const image = "_uqxi298qb2";
const contentWrapper = "_uqxc1w98gvy";
const textWrapper = "_uqxt6z79g7";
const title = "_uqxt1sga4vw";
const text = "_uqxt1cqu6dl";
const flipButton = "_uqxfjliozd";

export { contentWrapper, flipButton, image, imageWrapper, modifiers, text, textWrapper, title, wrapper };
import "./atom.card-side-style.linaria.module.css";
//# sourceMappingURL=atom.card-side-style.js.map
